import React, { useEffect, useReducer } from "react";

import Table from "./partials/Table";
import { parseQuerySimple } from "../../../helper/urlHelper";
import { useLocation } from 'react-router-dom'

export const Context = React.createContext(null);

const initialFilterData = {
  inputId: ''
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialFilterData);

  const location = useLocation();

  useEffect(() => {
    const queryObj = parseQuerySimple(location.search);
    if (queryObj.resultId) {
      const cleanResultId = queryObj.resultId.replace(/^"|"$/g, '')
      dispatch({
        type: 'SUBMIT_FILTER',
        payload: {
          ...state,
          inputId: cleanResultId
        }
      })
    }

  }, [location.search]) // not dependency of state => avoid loop forever

  useEffect(() => {
    document.title = "Vé"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>
      <Table />
    </Context.Provider>
  );
};
